module.exports = __webpack_public_path__ + "static/media/avatar.df24b824.jpg";